module.exports = __webpack_public_path__ + "img/sb4.efd2e1f7.png";